import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { VERIFICATION_URL } from '../constants';

export default function VerificationPage() {
  const { referenceNumber } = useParams();
  const [verification, setVerification] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchVerification() {
      try {
        const res = await fetch(`${VERIFICATION_URL}${referenceNumber}`);
        const data = await res.json();
        if (res.ok) {
          setVerification(data.verification);
        } else {
          setVerification(null);
        }
      } catch (error) {
        setVerification(null);
      } finally {
        setLoading(false);
      }
    }

    fetchVerification();
  }, [referenceNumber]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-gray-500">Loading verification...</p>
      </div>
    );
  }

  if (!verification) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-red-500 text-lg font-semibold">Verification record not found</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white shadow-md rounded-2xl p-8 space-y-6">
        <h2 className="text-3xl font-medium text-center text-primary">Credential Verification</h2>

        <div className="space-y-4">
          <div>
            <h4 className="text-sm font-semibold text-gray-500">Full Name</h4>
            <p className="text-lg font-medium text-gray-800">{verification.fullName}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-500">Qualification</h4>
            <p className="text-lg font-medium text-gray-800">{verification.qualification}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-gray-500">Institution</h4>
            <p className="text-lg font-medium text-gray-800">{verification.institution}</p>
          </div>

          {/* <div>
            <h4 className="text-sm font-semibold text-gray-500">Graduation Date</h4>
            <p className="text-lg font-medium text-gray-800">{verification.graduationDate}</p>
          </div> */}

          <div>
            <h4 className="text-sm font-semibold text-gray-500">UK Qualification Level</h4>
            <p className="text-lg font-medium text-gray-800">{verification.ukGrade}</p>
          </div>
        </div>

        <div className="text-center mt-6">
          <p className="text-green-600 font-medium text-xs">Verified by BC Verification</p>
        </div>
      </div>
    </div>
  );
}
